import { FronteggContext } from '@frontegg/rest-api';
import { showToastSuccess } from 'src/utilities/toast';
import { showToastError } from 'src/utilities/errortoast';
import { getAllTemplatesExchangeListSlice } from '../slices';
import {
  getAllTemplatesExchangeConfig,
  getDotPhraseByIdConfig,
  getDotPhraseConfig,
  getTemplateConfig,
  getTemplatesExchangeByIdConfig,
  getInsightHealthTemplatesListConfig,
  getInsightHealthTemplatesByIdConfig,
  assignInsightHealthTemplatesConfig,
} from '../lib/templatesexchange.url';
import { axiosAmbient } from 'src/lib/axios';
import {
  getAllDotPhraseExchangeListSlice,
  getDotPhraseByIdListSlice,
  getTemplatesExchangeByIdSlice,
  getInsightHealthTemplatesListSlice,
  getInsightHealthTemplatesByIdSlice,
  getTemplateExchangeCountSlice,
} from '../slices/templatesexchange.slice';

export const getAllTemplatesExchangeListAction = () => {
  return async (dispatch) => {
    try {
      const { url } = getAllTemplatesExchangeConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await axiosAmbient.get(url, { headers });
      const response = result?.data?.Aura_template_override_details;
      if (result?.status === 200 && response) {
        dispatch(getAllTemplatesExchangeListSlice(response));
        dispatch(
          getAllDotPhraseExchangeListSlice(
            result?.data?.Aura_dot_phrase_details
          )
        );
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getTemplateExchangeCountAction = () => {
  return async (dispatch) => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await axiosAmbient.get('/template_exchange/count', {
        headers,
      });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(getTemplateExchangeCountSlice(response));
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getInsightHealthTemplatesListAction = () => {
  return async (dispatch) => {
    try {
      const { url } = getInsightHealthTemplatesListConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await axiosAmbient.get(url, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(getInsightHealthTemplatesListSlice(response?.templates));
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getTemplatesExchangeByIdAction = (
  template_overrides_id,
  setTemplateOpen
) => {
  return async (dispatch) => {
    try {
      const { url } = getTemplatesExchangeByIdConfig(template_overrides_id);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await axiosAmbient.get(url, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(getTemplatesExchangeByIdSlice(response));
        setTemplateOpen(true);
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getInsightHealthTemplatesByIdAction = (
  template_id,
  setTemplateOpen
) => {
  return async (dispatch) => {
    try {
      const { url } = getInsightHealthTemplatesByIdConfig(template_id);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await axiosAmbient.get(url, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(getInsightHealthTemplatesByIdSlice(response));
        setTemplateOpen(true);
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getTemplateAction = (
  templateOverrideId,
  setTemplateOpen,
  templatesOverrideName
) => {
  return async (dispatch) => {
    try {
      const { url } = getTemplateConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const data = {
        template_overrides_id: templateOverrideId,
        template_overrides_name: templatesOverrideName,
      };
      const result = await axiosAmbient.post(url, data, { headers });
      if (result?.status === 200) {
        showToastSuccess('Template copied to your profile');
        setTemplateOpen(false);
        dispatch(getAllTemplatesExchangeListAction());
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getInsightHealthTemplateAction = (templateId, setTemplateOpen) => {
  return async (dispatch) => {
    try {
      const { url } = assignInsightHealthTemplatesConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const data = {
        template_id: templateId,
      };
      const result = await axiosAmbient.post(url, data, { headers });
      if (result?.status === 200) {
        showToastSuccess('Template copied to your profile');
        setTemplateOpen(false);
        dispatch(getAllTemplatesExchangeListAction());
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getDotPhraseAction = (
  dotPhraseOverrideId,
  setdotPhraseOpen,
  dotPhraseTitle
) => {
  return async (dispatch) => {
    try {
      const { url } = getDotPhraseConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const data = {
        dot_phrase_overrides_id: dotPhraseOverrideId,
        dot_phrase_overrides_name: dotPhraseTitle,
      };
      const result = await axiosAmbient.post(url, data, { headers });
      if (result?.status === 200) {
        showToastSuccess('Dot phrase copied to your profile');
        setdotPhraseOpen(false);
        dispatch(getAllTemplatesExchangeListAction());
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getDotPhraseByIdAction = (
  dot_phrase_overrides_id,
  setdotPhraseOpen
) => {
  return async (dispatch) => {
    try {
      const { url } = getDotPhraseByIdConfig(dot_phrase_overrides_id);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await axiosAmbient.get(url, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(getDotPhraseByIdListSlice(response));
        setdotPhraseOpen(true);
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};
